import CartController from "../../controllers/cartController";
import CartAlatauButton from "../cartAlatauButton";
import CartKaspiButton from "../cartKaspiButton";
import c from "./styles.module.scss";

const SuccessPaymentActions = ({ orderNumber }) => {
  const clearCart = async () => {
    await CartController.clearCart();
  };

  return (
    <div className={c.paymentActions}>
      <CartAlatauButton orderNumber={orderNumber} onSuccess={clearCart} />
      <CartKaspiButton orderNumber={orderNumber} onSuccess={clearCart} />
    </div>
  );
};

export default SuccessPaymentActions;
